import { render } from "./formDetail.vue?vue&type=template&id=1d1aa587"
import script from "./formDetail.vue?vue&type=script&lang=js"
export * from "./formDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__